export enum Status {
  // Zap templates of this type are Zaps created and shared by end users. The
  // rest are created by partners. So the "community" Zap templates are hidden
  // in the UI.
  community = 'community',
  invalid = 'invalid',
  draft = 'draft',
  forReview = 'for-review',
  rejected = 'rejected',
  published = 'published',
}

export enum StatusText {
  community = 'Community',
  invalid = 'invalid',
  draft = 'Draft',
  'for-review' = 'In Review',
  rejected = 'Rejected',
  published = 'Public',
}

type Service = {
  image: string;
  image16x16: string;
  image32x32: string;
  name: string;
  slug: string;
};

export type ZapTemplate = {
  headService: Service;
  id: string;
  slug: string;
  status: Status;
  tailService: Service;
  title: string;
  guidedRecipeUrl: string;
};
